@for (option of message().documentOptions; track option.fileId) {
    <li>
        <button
            qpxButton="unstyled"
            class="document-option"
            [class.selected]="isSelected(option)"
            [disabled]="isDisabled()"
            [attr.aria-label]="`Select document: ${optionLabel(option)}`"
            [attr.aria-busy]="
                message().documentSelectionStatus === 'pending' &&
                isSelected(option)
            "
            (click)="optionSelected.emit(option)"
        >
            <ng-icon qpx size="xs" name="lucideFileText" />
            <span
                class="min-w-0 truncate text-table-cell-sm font-semibold leading-5"
            >
                {{ optionLabel(option) }}
            </span>
            <span class="sr-only">
                {{ isSelected(option) ? 'Selected' : 'Select' }}
            </span>
            <ng-icon
                qpx
                size="xs"
                [name]="
                    message().documentSelectionStatus === 'selected' &&
                    isSelected(option)
                        ? 'lucideCheck'
                        : 'lucideChevronRight'
                "
            />
        </button>
    </li>
}
